export default () => ({
  alerts: null,
  newsItems: null,
  circles: [],
  doughnuts: [],
  computerEvolutionStats: { labels: [], datasets: [{ label: [], data: [] }] },
  alertEvolutionStats: { labels: [], datasets: [{ label: [], data: [] }] },
  vaccineEvolutionStats: { labels: [], datasets: [{ label: [], data: [] }] },
  agencyEvolutionStats: { labels: [], datasets: [{ label: [], data: [] }] },
  alertsPerDayEvolutionStats: { labels: [], datasets: [{ label: [], data: [] }] },
  agentsPerDayEvolutionStats: { labels: [], datasets: [{ label: [], data: [] }] },
  alertsPerVaccineEvolutionStats: { labels: [], datasets: [{ label: [], data: [] }] },
  loading: false,
  isStatsEvolutionError: false,
  pyramids: [],
  totalAlerts: 0,
  lastAlertsLength: 6,
});
